import { useEffect, useRef, useState } from 'react'
import { useProgress } from '@react-three/drei'

export function useFakeProgress({ step = 3, interval = 50 } = {}) {
  const { progress } = useProgress()
  const [percent, setPercent] = useState(0)
  const [done, setDone] = useState(false)
  const timerRef = useRef(null)
  const realDoneRef = useRef(false)

  useEffect(() => {
    realDoneRef.current = Number.isFinite(progress) && progress >= 100
  }, [progress])

  useEffect(() => {
    const tick = () => {
      setPercent(prev => {
        if (done) return prev

        // Tant que le réel n'est pas fini, on plafonne à 99
        if (!realDoneRef.current) {
          const next = Math.min(99, prev + step)
          return next
        }

        // Le réel est fini : si on est à 99 ou plus, on termine à 100
        if (prev >= 99) {
          clearInterval(timerRef.current)
          setDone(true)
          return 100
        }

        // Option "smooth" : on continue à 99 avant de passer à 100 au tick suivant
        return Math.min(99, prev + step)
      })
    }

    timerRef.current = setInterval(tick, interval)
    return () => clearInterval(timerRef.current)
  }, [step, interval, done])

  return { percent, done }
}
